module.exports = __webpack_public_path__ + "fe42c35d6827773b79b6c7a62e8c8fa4.png";